export const aboutData = {
    title: "Who I am",
    description1: "My name's Adityaraj. I'm a Ethical Hacker and Web-Developer based in Kolhapur, India.",
    description2: "So Basically I am 3rd-year CSE Student Studying in India Sanjay Ghodawat University, I am always energetic and eager to learn new skills. I am a dependable person who is great at time management. I’m currently learning Advanced Cloud Computing.",
    image: 2
}